'use client';

import { memo } from 'react';
import type { HealthIndex } from "../lib/wether/health.service";

interface MetricRowProps {
  label: string;
  index: HealthIndex;
  metricId: string;
  onClick: (id: string) => void;
}

const colorClasses = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  orange: 'bg-orange-500',
  red: 'bg-red-500',
} as const;

const BARS = [0, 1, 2, 3, 4];

function MetricRow({ label, index, metricId, onClick }: MetricRowProps) {
  return (
    <div className="py-3 border-b border-slate-700/60 last:border-b-0">
      <button
        type="button"
        onClick={() => onClick(metricId)}
        className="w-full text-left transition-colors duration-200 group cursor-pointer"
        aria-haspopup="dialog"
      >
        <div className="flex items-center justify-between gap-4">
          <span className="font-bold text-xl text-slate-200 group-hover:text-sky-400">{label}</span>

          <div className="flex items-center gap-2 shrink-0">
            <span className="font-bold text-lg text-slate-200">{index.score}</span>
            <div className="flex gap-1">
              {BARS.map((i) => (
                <div
                  key={i}
                  className={`w-2 h-5 rounded-sm ${i < index.score ? colorClasses[index.color] : 'bg-slate-600'}`}
                />
              ))}
            </div>
          </div>
        </div>
      </button>

      <p className="mt-1 text-slate-400 pl-1">{index.description}</p>
    </div>
  );
}

export default memo(MetricRow);
